<template>
    <div class="card p-3">
        <div class="row">
            <b-button variant="primary" @click="addIncentivo">Adicionar <i class="fa fa-plus"></i></b-button>
        </div>
        <div class="row mt-3">
            <div class="col">
                <b-table :items="lista" :fields="header"  :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    stacked="md"
                    show-empty
                    striped
                    hover                    
                    empty-text="Nada para exibir"
                    :busy="loading"
                    small>
                     <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Carregando ...</strong>
                        </div>
                    </template>
                <template #cell(id)="data">
                    <b-button variant="primary" @click="editaIncentivo(data.item)"><i class="fa fa-edit"></i></b-button>
                    <b-button variant="primary" class="mr-3" @click="destroy(data.value)"><i class="fas fa-trash"></i></b-button>
                </template>
                </b-table>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="my-0" />
            </div>
        </div>
         <b-modal v-model="modalIndique" :title="title" size="xl">
            <div class="card p-3">
                <div class="row mt-3">
                    <div class="col">
                        <label>Qtd. Indicados</label>
                        <b-form-input v-model="indique.quantidade" />
                    </div>
                    
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <label>Data Início</label>
                        <b-form-input v-model="indique.data_inicio" type="date" />
                    </div>
                    <div class="col">
                        <label>Data Encerramento</label>
                        <b-form-input v-model="indique.data_encerramento" type="date" />
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <label>Premio</label>
                        <v-select v-model="premios" :onSearch="buscaProduto" :options="showProdutos">                            
                        </v-select>
                    </div>
                    <div class="col">
                        <label>Quantidade Itens</label>
                        <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                            <b-form-input v-model="quantidade" v-mask="'###'" />
                            <b-button variant="primary" @click="adicionar"><i class="fa fa-plus"></i></b-button>
                        </b-input-group>
                    </div>
                </div>        
                <div class="row mt-3">
                    <div class="col">
                        <b-table-simple bordered borderless striped hover>
                            <b-thead head-variant="ligth">
                                <b-tr>
                                    <b-th>#</b-th>
                                    <b-th>Produto</b-th>
                                    <b-th>Quantidade </b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="lista, l in listaPremios" :key="l">
                                    <b-td> <b-button variant="primary" @click="removePremio"><i class="fas fa-trash"></i></b-button></b-td>
                                    <b-td> {{ lista.premios.value.codigo +' - '+ lista.premios.value.nome }}</b-td>
                                    <b-td>{{ lista.quantidade }}</b-td>
                                </b-tr>
                                
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </div>         
            </div>
            <template #modal-footer>
                <div class="w-100">
                    <p class="float-left"></p>
                    <b-button
                        variant="default"
                        size="sm"
                        class="float-right"
                        @click="showModal">
                        Cancelar
                    </b-button>
                    <b-button
                        variant="primary"
                        size="sm"
                        class="float-right"
                        @click="saveIncentivo">
                        Salvar
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: 'indique-ganhe',
    data() {
        return {
            indique: {
                id: null,
                premio: '',
                data_inicio: '',
                data_encerramento: '',
                quantidade: 1
            },
            modalIndique: false,            
            listaProdutos: [],
            loading: false,
            lista: [],
            header: [
                { key: 'id', label: '#', class: 'text-center' },
                { key: 'quantidade', label: 'Quantidade'},
                { key: 'data_inicio', label: 'Dt. Início', formatter: (value) => { return moment(value).format("DD/MM/YYYY")}},
                { key: 'data_encerramento', label: 'Dt. Encerramento', formatter: (value) => { return moment(value).format("DD/MM/YYYY")}}
            ],
            premios: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 35,
            pageOptions: [35, 45, 60],
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            title: '',
            listaPremios: [],
            quantidade: ""  
        }
    },
    methods: {
        destroy(id) {
            const vm = this
            vm.$swal.fire({
                title: 'Realmente deseja deletar este incentivo?',
                text: "Esta ação não poderá ser revertida!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim Deletar!',
                cancelButtonText:'Cancelar'
            }).then((result) => {
                if (result.value) {
                    $(".loading").show();
                    axios.delete("/adm/indique-ganhe/"+id).then((response) => {
                        console.log(response.data);
                        $(".loading").hide();
                        vm.buscainstivos();
                    }).catch(error => {
                        console.log("erro ao deletar ....", error);
                        $(".loading").hide();
                    });
                }
            })
        },
        removePremio(id) {
            this.listaPremios.splice(id,1);
        },
        adicionar() {
            if (this.premios === "") {
                return this.$swal("Informe uma premiação","Informe a premiação para esta indicação.","error");
            }
            if (parseInt(this.quantidade) <= 0) {
                return this.$swal("Informe a quantidade","Informe a quantidade de itens relacionados a premiação para esta indicação.","error");
            }
            this.listaPremios.push({
                quantidade: this.quantidade,
                premios: this.premios
            });
            this.quantidade = "";
            this.premios = "";
        },
        buscainstivos() {
            const vm = this;
            vm.loading = true;
            axios.get("/adm/indique-ganhe/listar").then((response) => {
                vm.lista = response.data;
                vm.totalRows = vm.lista.length;
                vm.loading = false;
            }).catch(error => {
                console.log(error);
                vm.loading = false;
            })
        },
        buscaProduto(key, loading) {
            const vm = this;
            if (key.length >= 4 ){
                axios.get("/produtos-all", { params: { codigo: key } }).then((response) => {
                    console.log(response.data);
                    vm.listaProdutos = response.data;
                    loading(false);
                }).catch( (error) => {
                    console.log(error);
                    loading(false);
                });
            }
        },
        showModal() {
            this.modalIndique = !this.modalIndique;
        },
        addIncentivo() {
            this.title ='Adicionando Premiação, Indique Ganhe';
            this.premios = "";
            this.indique = {
                id: null,
                premio: '',
                data_inicio: '',
                data_encerramento: '',
                quantidade: 1
            }
            this.listaPremios = [];
            this.showModal()
        },
        editaIncentivo(obj) {
            console.log(obj," obj");
            this.title ='Alterando Premiação '+ obj.id;
            let premio = JSON.parse(obj.premio);
            this.indique = obj;            
            this.listaPremios = premio;
            this.showModal();
        },
        saveIncentivo() {
            const vm = this;
            $(".loading").show();
           if (this.listaPremios.length <= 0){
               return this.$swal("Informe uma premiação.","","error");
           }
            this.indique.premio = JSON.stringify(this.listaPremios);
            axios.post("/adm/indique-ganhe",this.indique).then((response) => {
                //console.log(response.data);
                vm.showModal();                
                $(".loading").hide();
                vm.buscainstivos();
            }).catch((error) => {
                console.log(error,"erro ao salvar.");
                $(".loading").hide();
                vm.$swal("Ops","Houve um erro ao salvar",'error');
            })
        }
    },
    computed: {
        showProdutos() {
            let data = [];
            if (this.listaProdutos.length > 0) {
                this.listaProdutos.forEach(element => {
                    data.push({
                        label: element.codigo +' - '+ element.nome,
                        value: element 
                    });
                });
            }
            return data;
        }
    },
    mounted() {
        this.buscainstivos();
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/indique-ganhe/config.vue